import React from "react";
import {formatDistanceToNow} from "date-fns";
import {fr} from "date-fns/locale";

// Cartes des fils de discussion les plus actifs : titre, service, contributions, contributeurs, et (si demandé) la dernière
// contribution « il y a … ». Jamais le texte des messages.
export default function ThreadCards({threads, showActivity = false}) {
    return (
        <div className="threads">
            {threads.map(thread => (
                <div key={thread.id} className="thread-card">
                    <div className="thread-top">
                        <h3 className="serif">{thread.title}</h3>
                        <span className="thread-status mono">{thread.group_name}</span>
                    </div>
                    <span className="deadline mono">{thread.description}</span>
                    <div className="thread-footer">
                        <div className="avatars">
                            <span>{thread.contributor_count}</span>
                        </div>
                        <span>
                            {thread.post_count} contribution{thread.post_count > 1 ? "s" : ""}
                        </span>
                    </div>
                    {showActivity && thread.last_post_at && (
                        <span className="thread-activity mono">
                            Dernière contribution {formatDistanceToNow(new Date(thread.last_post_at), {locale: fr, addSuffix: true})}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}
